// extracted by css-extract-rspack-plugin
export default {"GitHubAvatar":"Participant-module__GitHubAvatar__p9RBAVQ"};